module.exports = __webpack_public_path__ + "static/redime-tus-puntos-2-6c3df5e67c804ba6620db30fd0d6b782.png";